const signal = "axon-icon__signal";

const path = (d, className) => ["path", { d, ...(className ? { className } : {}) }];
const rect = (x, y, width, height, className) => [
  "rect",
  { x, y, width, height, ...(className ? { className } : {}) },
];

export const iconRegistry = {
  today: [
    path("M4.5 8.5V19.5H19.5V8.5"),
    path("M4.5 5.5H10.5M13.5 5.5H19.5"),
    path("M8.5 3.5V7.5M15.5 3.5V7.5"),
    path("M8 11.5H12.5M8 15.5H16"),
    rect(15.25, 10.75, 1.5, 1.5, signal),
  ],
  lead: [
    path("M3.5 5.5H8L13 10.5"),
    path("M3.5 18.5H8L13 13.5"),
    path("M13 10.5V13.5"),
    path("M15.5 9L20.5 12L15.5 15"),
    rect(18.75, 11.25, 1.5, 1.5, signal),
  ],
  crm: [
    path("M4 5.5H9.5V10"),
    path("M11.5 12H15.5V18.5H20"),
    path("M9.5 10L11.5 12"),
    rect(2.75, 4.25, 2.5, 2.5),
    rect(18.75, 17.25, 2.5, 2.5),
    rect(9.75, 10.25, 2.5, 2.5, signal),
  ],
  quality: [
    path("M10 5.5L12 3.5L19.5 11M20.5 13L12 20.5L3.5 12L8.5 7"),
    path("M8.5 12L11 14.5L15.5 9.5"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  source: [
    path("M5.5 12H10.5M13.5 10.5L18 6M13.5 13.5L18 18"),
    rect(3.5, 10, 3, 4, signal),
    rect(18, 4.5, 2.5, 2.5),
    rect(18, 17, 2.5, 2.5),
  ],
  contact: [
    path("M12 3.5L15 6.5L12 9.5L9 6.5Z"),
    path("M5.5 19.5V16L9 12.5H15L18.5 16V19.5"),
    path("M5.5 5V3.5H8M16 3.5H18.5V5"),
    rect(10.75, 5.25, 2.5, 2.5, signal),
  ],
  organization: [
    path("M4 20V7H10.5V20M13.5 20V4H20V20M2.5 20H21.5"),
    path("M6.5 10H8M6.5 13.5H8M16 7H17.5M16 10.5H17.5M16 14H17.5"),
    rect(11.25, 18.75, 1.5, 1.5, signal),
  ],
  pipeline: [
    path("M4.5 12H9M11 12H15.5M17.5 12H20"),
    path("M4.5 9.5L7 12L4.5 14.5M9 9.5L11.5 12L9 14.5M15.5 9.5L18 12L15.5 14.5"),
    rect(10.75, 11.25, 1.5, 1.5, signal),
  ],
  nextAction: [
    path("M5.5 18.5H11.5V7H17"),
    path("M15 4.5L18.5 7L15 9.5"),
    rect(3.5, 16.5, 3, 3, signal),
  ],
  project: [
    path("M3.5 7.5H9L11 9.5H20.5V19.5H3.5V7.5Z"),
    path("M3.5 12H14M17 12H20.5"),
    rect(14.75, 11.25, 1.5, 1.5, signal),
  ],
  milestone: [
    path("M5.5 20V4M7.5 5H18L15.5 9H7.5"),
    path("M9 17.5H12.5M15.5 17.5H19"),
    rect(12.75, 16.25, 2.5, 2.5, signal),
  ],
  task: [
    path("M9 4.5H19.5V19.5H4.5V9"),
    path("M5 5.5L7 7.5L11 3.5"),
    path("M9 11.5H16M9 15.5H16"),
    rect(3.75, 6.25, 1.5, 1.5, signal),
  ],
  calendar: [
    path("M4.5 8V19.5H19.5V8M4.5 5.5H9M12 5.5H19.5M8.5 3.5V7M15.5 3.5V7"),
    path("M8 11.5H10M14 11.5H16M8 15.5H10M14 15.5H16"),
    rect(10.75, 4.75, 1.5, 1.5, signal),
  ],
  time: [
    path("M9 3.5H15L20.5 9V15L15 20.5H9L3.5 15V9L7 5.5"),
    path("M12 6.5V12L16 14.5"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  file: [
    path("M6 3.5H14L19 8.5V20.5H6V3.5Z"),
    path("M14 3.5V8.5H19M9 12H16M9 16H13"),
    rect(14.75, 15.25, 1.5, 1.5, signal),
  ],
  upload: [
    path("M6 9V4H14L18 8V20H6V16"),
    path("M14 4V8H18M4 14H12M8 10L12 14L8 18"),
    rect(3.25, 13.25, 1.5, 1.5, signal),
  ],
  conversation: [
    path("M4 5H17V14H10L6 18V14H4V5Z"),
    path("M10 17H16L20 20V9H18.5"),
    path("M7.5 9H10M13 9H15.5"),
    rect(10.75, 8.25, 1.5, 1.5, signal),
  ],
  send: [
    path("M3.5 5L20.5 12L3.5 19L6.5 13.5L14 12L6.5 10.5L3.5 5Z"),
    path("M8 12H11"),
    rect(11.75, 11.25, 1.5, 1.5, signal),
  ],
  approval: [
    path("M12 3.5L20.5 12L12 20.5L3.5 12L9 6.5"),
    path("M7.5 12L10.5 15L16.5 8.5"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  changeRequest: [
    path("M4 6H9L12 9M12 15L9 18H4M12 9V15M12 9L16 6H20M12 15L16 18H20"),
    path("M18 3.5V8.5M15.5 6H20.5"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  document: [
    path("M5.5 3.5H18.5V20.5H5.5V3.5Z"),
    path("M8.5 8H15.5M8.5 11.5H15.5M8.5 15H12M14.5 15H15.5"),
    rect(12.25, 14.25, 1.5, 1.5, signal),
  ],
  proposal: [
    path("M5 4H15L19 8V20H5V4Z"),
    path("M15 4V8H19M8 12H12M8 16H12"),
    path("M14.5 12L18.5 14.5L14.5 17"),
    rect(12.75, 13.75, 1.5, 1.5, signal),
  ],
  contract: [
    path("M4.5 4H13V19H4.5V4ZM11 7H19.5V20H11"),
    path("M7.5 9H10M7.5 13H10M14 11H17M14 15H17"),
    rect(10.25, 9.75, 1.5, 1.5, signal),
  ],
  invoice: [
    path("M6 3.5H18V20.5H6V3.5Z"),
    path("M9 8H15M9 12H12M14 12H15M9 16H15"),
    rect(12.25, 11.25, 1.5, 1.5, signal),
  ],
  payment: [
    path("M3.5 7H16.5V17H3.5V7ZM7 10.5H13"),
    path("M16.5 10H20.5M18.5 8L20.5 10L18.5 12"),
    rect(5.5, 13.25, 2.5, 1.5, signal),
  ],
  receipt: [
    path("M6 3.5H18V20.5L15.5 18.5L13 20.5L10.5 18.5L8 20.5L6 19V3.5Z"),
    path("M9 8H15M9 12H12M14 12H15"),
    path("M9 15L10.5 16.5L13.5 13.5"),
    rect(13.75, 14.25, 1.5, 1.5, signal),
  ],
  analytics: [
    path("M4 19.5V5M4 19.5H20"),
    path("M7 16V12M11 16V8M15 16V10M19 16V4.5"),
    rect(10.25, 6.5, 1.5, 1.5, signal),
  ],
  attribution: [
    path("M12 4L20 12L12 20L4 12L9 7"),
    path("M7 12H10M14 12H19.5"),
    rect(10, 10, 4, 4, signal),
  ],
  referral: [
    path("M5 12H11M13 12L18 7M13 12L18 17"),
    path("M16 5H20V9M16 15H20V19"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  publicProfile: [
    path("M4 4.5H16V19.5H4V4.5Z"),
    path("M10 7L12.5 9.5L10 12L7.5 9.5Z"),
    path("M6.5 17V15L8.5 13.5H11.5L13.5 15V17"),
    path("M16 8H20M18 6L20 8L18 10"),
    rect(15.25, 7.25, 1.5, 1.5, signal),
  ],
  case: [
    path("M4 5H20V19H4V5Z"),
    path("M4 9H20M8 9V19M11 15L13 12L15 14L18 10"),
    rect(16.75, 9.75, 1.5, 1.5, signal),
  ],
  review: [
    path("M4 5H20V17H12L8 20V17H4V5Z"),
    path("M8 9H11M13 9H16M8 13H14"),
    rect(14.75, 8.25, 1.5, 1.5, signal),
  ],
  notification: [
    path("M6 16.5H18L16.5 14V9L14 5.5H10L7.5 9V14L6 16.5Z"),
    path("M9.5 19H14.5M16 4H19V7"),
    rect(17, 5, 2, 2, signal),
  ],
  search: [
    path("M10 3.5L16.5 6.5L19.5 13L16.5 17.5L11 19.5L5 16.5L3.5 11L6 6"),
    path("M15.5 16.5L20.5 21"),
    rect(9.75, 10.75, 2.5, 2.5, signal),
  ],
  filter: [
    path("M4 6H10M13 6H20M4 12H7M10 12H20M4 18H14M17 18H20"),
    rect(10.75, 4.75, 2.5, 2.5, signal),
    rect(7.75, 10.75, 2.5, 2.5),
    rect(14.75, 16.75, 2.5, 2.5),
  ],
  settings: [
    path("M4 6H8M11 6H20M4 12H14M17 12H20M4 18H10M13 18H20"),
    rect(8.25, 4.75, 2.5, 2.5, signal),
    rect(14.25, 10.75, 2.5, 2.5),
    rect(10.25, 16.75, 2.5, 2.5),
  ],
  warning: [
    path("M12 3.5L21 20H3L10.5 6"),
    path("M12 9V14M12 17V17.5"),
    rect(10.75, 16.25, 2.5, 2.5, signal),
  ],
  archive: [
    path("M4 7.5H20V20H4V7.5ZM3 4H21V7.5H3V4Z"),
    path("M12 9.5V15M9.5 12.5L12 15L14.5 12.5"),
    rect(10.75, 15.75, 2.5, 1.5, signal),
  ],
  plus: [
    path("M12 5V19M5 12H19"),
    path("M4 8V4H8M16 4H20V8M20 16V20H16M8 20H4V16"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  check: [
    path("M4 12.5L9.5 18L20 6.5"),
    path("M4 7V4H7M17 20H20V17"),
    rect(8.25, 16.75, 2.5, 2.5, signal),
  ],
  close: [
    path("M5 5L19 19M19 5L5 19"),
    path("M4 9V4H9M15 20H20V15"),
    rect(10.75, 10.75, 2.5, 2.5, signal),
  ],
  more: [
    path("M4 12H6M11 12H13M18 12H20"),
    rect(10.25, 10.25, 3.5, 3.5, signal),
  ],
};

export const iconNames = Object.freeze(Object.keys(iconRegistry));
